























































import { mapGetters } from "vuex";
import { General, App } from "@/utils/constants";
import { IStatusList } from "@/components/types/processStatus";

export default {
  name: "ProcessStatus",
  props: {
    process: {
      type: Object,
      required: true
    },
    statusList: {
      type: Array as () => IStatusList[],
      required: true
    }
  },
  data() {
    return {
      General,
      App
    };
  },
  computed: {
    ...mapGetters(["isContrast"])
  },
  methods: {
    displayStatus(status: IStatusList) {
      return this.statusList.includes(status);
    }
  }
};
